/**
 * 经营大脑（三核一舱）门户路由
 *
 * Phase A: 单入口门户,不改现有菜单结构。
 * Phase B1: 增加 SFE 派单中心(增长驱动核真实闭环)。
 */

const OperationBrainPortal = () => import('@/views/operation-brain/index.vue')
const SfeDispatchList = () => import('@/views/operation-brain/sfe-dispatch/SfeDispatchList.vue')
const SfeMyTasks = () => import('@/views/operation-brain/sfe-dispatch/SfeMyTasks.vue')

const operationBrainRoutes = [
  {
    path: '/operation-brain',
    name: 'OperationBrain.Portal',
    component: OperationBrainPortal,
    meta: { title: '经营大脑', requiresAuth: true }
  },
  {
    path: '/operation-brain/sfe-dispatch',
    name: 'OperationBrain.SfeDispatch.List',
    component: SfeDispatchList,
    meta: { title: 'SFE 派单中心', requiresAuth: true }
  },
  {
    path: '/operation-brain/sfe-dispatch/my-tasks',
    name: 'OperationBrain.SfeDispatch.MyTasks',
    component: SfeMyTasks,
    meta: { title: '我的派单任务', requiresAuth: true }
  }
]

export default operationBrainRoutes
